<template>
  <div id="paginador" class="w3-center w3-display-container">
    <div class="w3-bar w3-round pages">
      <div v-show="this.page.pagesNumber > 1" class="paginator-controls">
        <span :class="['w3-bar-item', 'w3-button', 'movePage', {'disabled':(page.number === 1)}]" @click="previousPage($event)">
          <i class="fa fa-caret-left"></i>
        </span>
        <input :class="['w3-bar-item', 'w3-button', 'w3-input', 'pageNumber']" type="text" v-model="fieldNumber" @blur="refreshPageNumber($event)" @keyup="getSearcherPage($event)">
        <span :class="['w3-bar-item', 'totalPages']"> / {{ num(page.pagesNumber) }}</span>
        <span :class="['w3-bar-item', 'w3-button', 'movePage', {'disabled' : (page.number === page.pagesNumber)}]" @click="nextPage($event)">
          <i class="fa fa-caret-right"></i>
        </span>
      </div>
      <div :class="['results']">
        <span class="total-rows">{{ num(page.totalRows) }} {{$ml.get('results')}}</span>
        <template v-if="downloadResults && page.totalRows <= 50000">
          <transition name="fade" mode="out-in">
            <button v-if="!downloadingResults" @click="downloadResultsEvent($event)" class="download-button" :title="$ml.get('downloadResults')">
              <i class="fa fa-download"></i>
            </button>
            <spinner-loading v-else class="downloading-results" :line-size='2' :size="16" line-fg-color='#5dbecd' />
          </transition>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import prettify from '@/utils/prettify'

export default {
  name: 'searcher-paginator',
  props: [
    'requestSearcher',
    'downloadingResults',
    'isGalleryImage'
  ],
  data () {
    return {
      page: this.requestSearcher.requestPage,
      fieldNumber: this.requestSearcher.requestPage.number,
      downloadResults: (this.requestSearcher.downloadResults && !this.isGalleryImage)
    }
  },
  methods: {
    previousPage (event) {
      if (this.fieldNumber > 1) {
        this.fieldNumber = this.fieldNumber - 1
        this.page.number = this.fieldNumber
        this.refreshPage()
      }
    },
    nextPage (event) {
      if (this.fieldNumber < this.page.pagesNumber) {
        this.fieldNumber = this.fieldNumber + 1
        this.page.number = this.fieldNumber
        this.refreshPage()
      }
    },
    refreshPageNumber (event) {
      if (this.checkPageNumber()) {
        this.refreshPage()
      }
    },
    getSearcherPage (event) {
      if (event.key === 'Enter') {
        if (this.checkPageNumber()) {
          this.refreshPage()
        }
      } else {
        if (this.fieldNumber.trim() !== '' && !this.isNormalInteger(this.fieldNumber, this.page.pagesNumber)) {
          this.fieldNumber = this.page.number
        }
      }
    },
    refreshPage () {
      this.$emit('refreshPage', this.page.number)
    },
    checkPageNumber () {
      var result = false
      if (this.fieldNumber < 1) {
        this.fieldNumber = 1
      } else if (this.fieldNumber > this.page.pagesNumber) {
        this.fieldNumber = this.page.pagesNumber
      }
      if (this.page.number !== this.fieldNumber) {
        this.page.number = this.fieldNumber
        result = true
      }
      return result
    },
    isNormalInteger (str, max) {
      var n = Math.floor(Number(str))
      var nMax = Math.floor(Number(max))
      return n !== Infinity && String(n) === str && n > 0 && n <= nMax
    },
    downloadResultsEvent (event) {
      this.$emit('downloadResults')
    },
    num (num) {
      return prettify.methods.num(num)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  #paginador {
    position: absolute;
    left: 0;
    right: 13px;
    bottom: 0;
    background-color: #ffffffe4;
    padding: 4px 0 3px;
    line-height: 0;
    border: 1px solid #d2d2d2;

    .pages {
      background-color: #fff;
      padding: 3px 3px 2px;
      font-size: 11px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .totalPages {
      margin-top: 2px;
      margin-right: 10px;
      font-size: 0.9em;
      color: #777;
      padding-right: 0;
      padding-top: 12px;
    }
    .pageNumber {
      padding: 7px 0 7px;
      width: 52px;
      border-radius: 0;
      background-color: #fff;
      cursor: text;
      transition: all 0.2s ease-in;
    }
    .movePage {
      transition: all 0.2s ease-in;
    }
    .movePage:hover{
      color: #d42e12 !important;
      background-color: #efefef !important;
    }
    .movePage.disabled,
    .movePage.disabled:hover{
      color: #cccccc !important;
      background-color: #efefef !important;
      cursor: default;
    }
    .paginator-controls {
      float: left;
    }
    .results {
      display: inline-block;
      position: initial;
      line-height: initial;
      margin-left: 5px;
    }
    .w3-button.disabled {
      color: #ccc;
    }
    .w3-display-topright {
      top: 5px;
    }
    .downloading-results {
      display: inline-block;
      vertical-align: middle;
      margin: 0px 7px 0 20px;
    }
    .download-button {
      display: inline-block;
      vertical-align: middle;
      margin: 0 0 0 5px;
      border: 0;
      width: initial;
      cursor: pointer;
      background-color: #fff;

      i {
        font-size: 14px;
        color: #d42e12;
        transition: all 0.2s ease-in;
        width: 16px;

        &:hover {
          color: #d42e12;
        }
      }
    }
  }
</style>
